<template>
  <div class="mt-5 w-full flex flex-wrap">
    <delete-error-serials-popup
      :show="deletePopup"
      @close="close"
      @deleteSerials="deleteSerials"
    ></delete-error-serials-popup>
    <div
      v-for="(wrong, index) in wrongList"
      class="border-1 border-solid border-danger rounded-lg w-2/5 p-3 flex justify-between items-center m-1"
    >
      <div>
        <span>{{ $t("WrongBarcode") }}</span
        >:
        <span>{{ wrong.serial }}</span>
      </div>
      <vs-button
        radius
        color="danger"
        size="small"
        type="gradient"
        icon-pack="feather"
        icon="icon-x"
        @click.prevent="deleteSerialPopup(wrong.serial, index, 'wrong')"
        class="d-inline"
      ></vs-button>
    </div>
    <div
      v-for="(extera, index) in exteraList"
      class="border-1 border-solid border-danger rounded-lg w-2/5 p-3 flex justify-between items-center m-1"
    >
      <div>
        <span>{{ $t("ExteraBarcode") }}</span
        >:
        <span>{{ extera.serial }}</span>
      </div>
      <vs-button
        radius
        color="danger"
        size="small"
        type="gradient"
        icon-pack="feather"
        icon="icon-x"
        @click.prevent="deleteSerialPopup(extera.serial, index, 'extera')"
        class="d-inline"
      ></vs-button>
    </div>
    <!-- <div
      v-for="duplicte in duplicateList"
      class="border-1 border-solid border-warning rounded-lg w-2/5 p-3 flex justify-between items-center m-1"
    >
      <div>
        <span>{{ $t("DuplicteBarcode") }}</span
        >:
        <span>{{ duplicte.serial }}</span>
      </div>
    </div> -->
  </div>
</template>
<script>
import DeleteErrorSerialsPopup from "./DeleteErrorSerialsPopup.vue";
export default {
  data() {
    return {
      deletePopup: false,
      wrongDeleteAction: false,
      exteraDeleteAction: false,
      deleteIndex: 0,
    };
  },
  components: {
    DeleteErrorSerialsPopup,
  },
  props: {
    allValidSerials: {
      type: Array,
      default: [],
    },
    wrongList: {
      type: Array,
      default: [],
    },
    exteraList: {
      type: Array,
      default: [],
    },
    duplicateList: {
      type: Array,
      default: [],
    },
  },

  methods: {
    deleteSerialPopup(data, index, type) {
      if (type === "extera") {
        this.exteraDeleteAction = true;
      } else if (type === "wrong") {
        this.wrongDeleteAction = true;
      } else {
        this.wrongDeleteAction = false;
        this.exteraDeleteAction = false;
      }
      this.deleteIndex = index;
      this.deletePopup = true;
    },
    close() {
      this.deletePopup = false;
      this.wrongDeleteAction = false;
      this.exteraDeleteAction = false;
    },
    deleteSerials(serial) {
      if (this.wrongDeleteAction) {
        for (let index = 0; index < this.wrongList.length; index++) {
          if (this.wrongList[index].serial.trim()  === serial.trim() ) {
            this.wrongList.splice(this.deleteIndex, 1),
              this.$swal({
                position: "center-center",
                type: "success",
                text: "سریال با موفقیت حذف شد",
                showConfirmButton: false,
                timer: 1000,
              });

            this.close();
            break
          } else {
            this.$swal({
              position: "center-center",
              type: "error",
              text: "سریال مطابقت ندارد",
              showConfirmButton: true,
            });
          }
        }
      } else if (this.exteraDeleteAction) {
        for (let index = 0; index < this.exteraList.length; index++) {
          if (this.exteraList[index].serial.trim()  === serial.trim() ) {
            this.exteraList.splice(this.deleteIndex, 1),
              this.$swal({
                position: "center-center",
                type: "success",
                text: "سریال با موفقیت حذف شد",
                showConfirmButton: false,
                timer: 1000,
              });

            this.close();
            break
          } else {
            this.$swal({
              position: "center-center",
              type: "error",
              text: "سریال مطابقت ندارد",
              showConfirmButton: true,
            });
          }
        }
      }
    },
  },
};
</script>
